(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
const selector='[data-rc-cinema-hero]';
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
function setup(hero){
  if(hero.dataset.rcCinemaReady==='true')return;
  hero.dataset.rcCinemaReady='true';
  const slides=Array.from(hero.querySelectorAll('[data-rc-cinema-slide]'));
  if(!slides.length)return;
  const dots=Array.from(hero.querySelectorAll('[data-rc-dot]'));
  const count=hero.querySelector('[data-rc-cinema-index]');
  const motion=null;
  let active=0,paused=false,timer=null;
  const interval=Number(hero.dataset.duration)||9000;
  function cancel(){if(timer){clearInterval(timer);timer=null}}
  function shouldPlay(){return !paused&&!reduced.matches&&!document.hidden}
  function sync(){
    slides.forEach((slide,i)=>{
      const selected=i===active;
      slide.hidden=!selected;
      slide.classList.toggle('is-active',selected);
      slide.querySelectorAll('video').forEach(v=>{
        const mobile=v.classList.contains('rc-cinema-video-mobile');
        const desktop=v.classList.contains('rc-cinema-video-desktop');
        const mobileVideo=slide.querySelector('.rc-cinema-video-mobile');
        const use=selected&&(!mobile||window.innerWidth<=760)&&(!desktop||window.innerWidth>760||!mobileVideo);
        v.muted=true;v.defaultMuted=true;v.volume=0;if(use&&shouldPlay()){const result=v.play();if(result&&result.catch)result.catch(()=>{});}
        else v.pause();
      });
    });
    dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===active)));
    if(count)count.textContent=String(active+1).padStart(2,'0');
    if(motion){motion.setAttribute('aria-pressed',String(paused));motion.setAttribute('aria-label',paused?'Resume animation':'Pause animation');const icon=motion.querySelector('[data-rc-motion-icon]');if(icon)icon.textContent=paused?'▶':'Ⅱ';}
  }
  function show(i){active=(i+slides.length)%slides.length;sync()}
  function run(){cancel();if(slides.length>1&&!paused&&!reduced.matches&&!document.hidden&&!window.Shopify?.designMode){timer=setInterval(()=>show(active+1),Math.max(5500,interval));}}
  hero.querySelector('[data-rc-prev]')?.addEventListener('click',()=>{show(active-1);run()});
  hero.querySelector('[data-rc-next]')?.addEventListener('click',()=>{show(active+1);run()});
  dots.forEach((b,i)=>b.addEventListener('click',()=>{show(i);run()}));
  motion?.addEventListener('click',()=>{paused=!paused;sync();run()});
  hero.addEventListener('mouseenter',cancel);
  hero.addEventListener('mouseleave',run);
  hero.addEventListener('focusin',cancel);
  hero.addEventListener('focusout',e=>{if(!hero.contains(e.relatedTarget))run()});
  document.addEventListener('visibilitychange',()=>{sync();run()});
  window.addEventListener('resize',sync);
  reduced.addEventListener?.('change',()=>{sync();run()});
  document.addEventListener('shopify:block:select',e=>{
    const block=e.detail?.blockId;
    const slide=slides.find(s=>s.dataset.blockId===block);
    if(!slide)return;
    cancel();show(slides.indexOf(slide));
  });
  sync();run();
}
function start(root){root.querySelectorAll(selector).forEach(setup)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(document));
else start(document);
document.addEventListener('shopify:section:load',e=>start(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  function init(root){
    const items=[];
    if(root.matches?.('[data-rc-pdp]'))items.push(root);
    root.querySelectorAll?.('[data-rc-pdp]').forEach(x=>items.push(x));
    items.forEach(section=>{
      if(section.dataset.rcPdpReady)return;
      section.dataset.rcPdpReady='true';
      const select=section.querySelector('[data-variant-select]');
      const saving=section.querySelector('[data-rcp-savings]');
      const amount=section.querySelector('[data-rcp-saved-amount]');
      const percent=section.querySelector('[data-rcp-percent]');
      const imageTag=section.querySelector('[data-rcp-image-sale]');
      const stickyPrice=section.querySelector('[data-rcp-sticky-price]');
      const stock=section.querySelector('[data-rcp-status]');
      const sticky=section.querySelector('[data-rcp-sticky]');
      const actions=section.querySelector('[data-rcp-actions]');
      const money=(n)=>new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:window.Shopify?.currency?.active||'INR',maximumFractionDigits:2,minimumFractionDigits:0}).format(n/100);
      function update(){
        if(!select)return;
        const opt=select.selectedOptions[0];if(!opt)return;
        const p=Number(opt.dataset.priceCents||0),c=Number(opt.dataset.compareCents||0);
        const isSale=c>p&&c>0;
        const pct=isSale?Math.round((c-p)/c*100):0;
        if(stickyPrice)stickyPrice.textContent=opt.dataset.price||money(p);
        if(saving)saving.hidden=!isSale;
        if(amount)amount.textContent=money(c-p);
        if(percent){percent.hidden=!isSale;percent.textContent=pct+'% OFF'}
        if(imageTag){imageTag.hidden=!isSale;imageTag.textContent='Save '+pct+'%'}
        if(stock){const available=opt.dataset.available==='true';stock.innerHTML=available?'<span class="rc-pdp__status-dot"></span> Available to order':'Currently unavailable';stock.style.color=available?'#56725b':'#9a4545'}
      }
      select?.addEventListener('change',update);update();
      if(!sticky||!actions)return;
      const visible=()=>{
        if(window.innerWidth>760){sticky.classList.remove('is-visible');return}
        const box=section.getBoundingClientRect(),purchase=actions.getBoundingClientRect();
        const inSection=box.bottom>90;
        const buttonsVisible=purchase.bottom>65&&purchase.top<window.innerHeight-70;
        sticky.classList.toggle('is-visible',inSection&&!buttonsVisible&&window.scrollY>230);
      };
      window.addEventListener('scroll',visible,{passive:true});
      window.addEventListener('resize',visible,{passive:true});
      visible();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));
  else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

/* Visitor-specific daily four-hour display, shared across all products in this browser.
   This UI countdown is not a Shopify discount expiry mechanism. */
(function(){
 function setup(root){
  const sections=[];
  if(root.matches?.('[data-rc-pdp]'))sections.push(root);
  root.querySelectorAll?.('[data-rc-pdp]').forEach(el=>sections.push(el));
  sections.forEach(section=>{
   if(section.dataset.rcOfferReady)return;
   section.dataset.rcOfferReady='1';
   const timer=section.querySelector('[data-rcp-offer-timer]');
   if(timer){
    const raw=timer.dataset.rcpDeadline;
    const fixed=!!raw&&Number.isFinite(Date.parse(raw));
    const key=timer.dataset.rcpTimerKey||'rc-ritualscart-daily-visitor-4hour-window-v2';
    const dailyLabel="Today's 4-Hour Window";
    const currentLocalDay=()=>{
      const d=new Date();
      const part=n=>String(n).padStart(2,'0');
      return d.getFullYear()+'-'+part(d.getMonth()+1)+'-'+part(d.getDate());
    };
    let currentDay=currentLocalDay();
    function dailyDeadline(day){
      try{
        const stored=JSON.parse(window.localStorage.getItem(key)||'null');
        if(stored&&stored.day===day&&Number.isFinite(Number(stored.endsAt))&&Number(stored.endsAt)>0){
          return Number(stored.endsAt);
        }
      }catch(e){}
      const endsAt=Date.now()+4*60*60*1000;
      try{window.localStorage.setItem(key,JSON.stringify({day,endsAt}))}catch(e){}
      return endsAt;
    }
    let target=fixed?Date.parse(raw):dailyDeadline(currentDay);
    const hh=timer.querySelector('[data-rcp-hours]');
    const mm=timer.querySelector('[data-rcp-minutes]');
    const ss=timer.querySelector('[data-rcp-seconds]');
    const title=timer.querySelector('[data-rcp-timer-title]');
    const pad=n=>String(n).padStart(2,'0');
    let interval;
    function tick(){
      if(!fixed){
        const day=currentLocalDay();
        if(day!==currentDay){
          currentDay=day;
          target=dailyDeadline(day);
          if(title)title.textContent=dailyLabel;
          timer.classList.remove('is-expired');
        }
      }
      const left=Math.max(0,Math.ceil((target-Date.now())/1000));
      if(hh)hh.textContent=pad(Math.floor(left/3600));
      if(mm)mm.textContent=pad(Math.floor(left%3600/60));
      if(ss)ss.textContent=pad(left%60);
      if(!left){
        if(title)title.textContent=fixed?'Offer Ended':"Today's Window Complete";
        timer.classList.add('is-expired');
        if(fixed&&interval)clearInterval(interval);
      }
    }
    tick();
    // Daily mode keeps checking for a new local calendar day even after today's window ends.
    if(!fixed||target>Date.now())interval=setInterval(tick,1000);
    const onStorage=event=>{
      if(fixed||event.key!==key||!event.newValue)return;
      try{
        const changed=JSON.parse(event.newValue);
        if(changed.day===currentLocalDay()&&Number.isFinite(Number(changed.endsAt))&&Number(changed.endsAt)>0){
          currentDay=changed.day;
          target=Number(changed.endsAt);
          timer.classList.remove('is-expired');
          if(title)title.textContent=dailyLabel;
          tick();
        }
      }catch(e){}
    };
    window.addEventListener('storage',onStorage);
    section.addEventListener('shopify:section:unload',()=>{clearInterval(interval);window.removeEventListener('storage',onStorage)},{once:true});
   }
   const select=section.querySelector('[data-variant-select]');
   const offer=section.querySelector('[data-rcp-price-offer]');
   const copy=section.querySelector('[data-rcp-offer-copy]');
   const wrapper=section.querySelector('[data-rcp-offers]');
   function sync(){
    if(!select)return;
    const o=select.selectedOptions[0];if(!o)return;
    const p=Number(o.dataset.priceCents),c=Number(o.dataset.compareCents),on=c>p&&c>0;
    if(offer)offer.hidden=!on;
    const pct=on?Math.round((c-p)/c*100):0;
    if(copy&&on){
      let str;
      try{str=new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:window.Shopify?.currency?.active||'INR',maximumFractionDigits:2,minimumFractionDigits:0}).format((c-p)/100)}catch(e){str=String((c-p)/100)}
      copy.textContent='Save '+str+' ('+pct+'% off) on this item';
    }
    if(wrapper)wrapper.hidden=!on&&!wrapper.querySelector('[data-copy-offer]');
   }
   select?.addEventListener('change',sync);sync();
   section.addEventListener('click',async e=>{
     const button=e.target.closest('[data-copy-offer]');
     if(!button)return;
     const code=button.dataset.copyOffer;
     try{await navigator.clipboard.writeText(code);button.textContent='Copied!';setTimeout(()=>{button.textContent='Copy '+code},1700)}
     catch(err){button.textContent='Code: '+code}
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document));else setup(document);
 document.addEventListener('shopify:section:load',e=>setup(e.target));
})();


/* Product review carousel: one full-width card at a time, auto advance and swipe. */
(function(){
 function setup(root){
  const sections=[];
  if(root.matches?.('[data-rc-pdp]'))sections.push(root);
  root.querySelectorAll?.('[data-rc-pdp]').forEach(el=>sections.push(el));
  sections.forEach(section=>{
   const track=section.querySelector('[data-rcp-reviews-track]');
   if(!track||track.dataset.rcReviewCarouselReady)return;
   track.dataset.rcReviewCarouselReady='1';
   const cards=Array.from(track.querySelectorAll('.rc-pdp__client-card'));
   const dots=Array.from(section.querySelectorAll('[data-review-dot]'));
   let current=0,pauseUntil=0;
   function activate(index){
    current=index;
    dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===index);dot.setAttribute('aria-pressed',String(i===index))});
   }
   function moveTo(index){
    if(!cards.length)return;
    const next=(index+cards.length)%cards.length;
    const gap=parseFloat(getComputedStyle(track).columnGap)||0;
    const size=cards[0].getBoundingClientRect().width+gap;
    track.scrollTo({left:next*size,behavior:'smooth'});
    activate(next);
   }
   function pause(){pauseUntil=Date.now()+7000}
   ['pointerdown','touchstart','wheel','focusin'].forEach(event=>track.addEventListener(event,pause,{passive:true}));
   dots.forEach((dot,i)=>dot.addEventListener('click',()=>{pause();moveTo(i)}));
   let scrollTimeout;
   track.addEventListener('scroll',()=>{
    clearTimeout(scrollTimeout);
    scrollTimeout=setTimeout(()=>{
     if(!cards.length)return;
     const gap=parseFloat(getComputedStyle(track).columnGap)||0;
     const size=cards[0].getBoundingClientRect().width+gap;
     if(size>0)activate(Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/size))));
    },70);
   },{passive:true});
   const interval=setInterval(()=>{
    if(cards.length<2||document.hidden||Date.now()<pauseUntil||track.matches(':hover')||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const bounds=track.getBoundingClientRect();
    if(bounds.bottom<0||bounds.top>window.innerHeight)return;
    moveTo(current+1);
   },3000);
   section.addEventListener('shopify:section:unload',()=>{clearInterval(interval);clearTimeout(scrollTimeout);track.dataset.rcReviewCarouselReady=''},{once:true});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document));else setup(document);
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();

/* Sync accessibility state when user changes product thumbnail. */
(function(){
 function init(root){
  const groups=[];
  if(root.matches?.('[data-rc-pdp]'))groups.push(root);
  root.querySelectorAll?.('[data-rc-pdp]').forEach(x=>groups.push(x));
  groups.forEach(section=>{
   const gallery=section.querySelector('[data-gallery-thumbs]');
   if(!gallery||gallery.dataset.rcGalleryAccessible)return;
   gallery.dataset.rcGalleryAccessible='1';
   gallery.addEventListener('click',e=>{
     const button=e.target.closest('[data-gallery-src]');
     if(!button)return;
     gallery.querySelectorAll('[data-gallery-src]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrollable-video-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
  root.querySelectorAll('.rc-reels').forEach(section=>{
    if(section.dataset.rcReelsReady)return;
    section.dataset.rcReelsReady='1';
    const track=section.querySelector('[data-reels-track]');if(!track)return;
    const vids=Array.from(track.querySelectorAll('video'));
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{const v=entry.target;v.muted=true;v.defaultMuted=true;if(entry.isIntersecting&&document.visibilityState==='visible'){const play=v.play();if(play?.catch)play.catch(()=>{});}else v.pause()})},{root:track,threshold:0.35});
    vids.forEach(v=>{v.muted=true;v.defaultMuted=true;v.loop=true;v.removeAttribute('controls');observer.observe(v)});
    document.addEventListener('visibilitychange',()=>vids.forEach(v=>{if(document.hidden)v.pause();else if(v.getBoundingClientRect().width){const p=v.play();if(p?.catch)p.catch(()=>{})}}));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
